import { render, staticRenderFns } from "./advertisement-edit.vue?vue&type=template&id=64fd7dd0&scoped=true"
import script from "./advertisement-edit.vue?vue&type=script&lang=js"
export * from "./advertisement-edit.vue?vue&type=script&lang=js"
import style0 from "./advertisement-edit.vue?vue&type=style&index=0&id=64fd7dd0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fd7dd0",
  null
  
)

export default component.exports